import styled from '@emotion/styled';

export const StyledWidgetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 16px;
  margin: 0 -16px;
  background: none;

  @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
    flex-direction: row;
  }

  @media (min-width: ${(props) => props.theme.breakpoints.tablet_landscape}) {
    padding: 20px 24px;
    margin: 0 -24px;
  }
`;
